module.exports = __webpack_public_path__ + "img/mail.29d853e.svg";